import { render } from "./ButtonRemoveFromCart.vue?vue&type=template&id=cde11ba8&ts=true"
import script from "./ButtonRemoveFromCart.vue?vue&type=script&lang=ts"
export * from "./ButtonRemoveFromCart.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__